import { createSlice } from '@reduxjs/toolkit';

export type RefererPingResponse = {
  discoveredRefererId: string | null;
  visitorId_employerTag: string | null;
  visitorId_voucherCode: string | null;
  discoveredRefererUsername: string | null;
};

const refererPingSlice = createSlice({
  name: 'refererPing',
  initialState: {
    data: null as RefererPingResponse | null,
  },
  reducers: {
    setRefererPingData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setRefererPingData } = refererPingSlice.actions;

export default refererPingSlice.reducer;
